import {make} from 'vuex-pathify'

const state = {
    drawer: null,
    drawerImage: false,
    mini: true,
    items: [
        {
            title: 'Início',
            icon: 'mdi-view-dashboard',
            to: '/inicio',
        },
        {
            title: 'Clientes',
            icon: 'mdi-account-search',
            to: '/clientes',
        },
        {
            title: 'Contratos',
            icon: 'mdi-file-document',
            to: '/contratos',
        },
        {
            title: 'Contas a Receber',
            icon: 'mdi-cash-multiple',
            to: '/receber',
        },
        {
            title: 'Usuários',
            icon: 'mdi-account-key',
            to: '/usuarios',
        },
    ],
}

const mutations = make.mutations(state)

const actions = {
    ...make.actions(state),
    init: async ({dispatch}) => {
        //
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
